export const setuserInfo = {
    SET_USER_TOKEN:"SET_USER_TOKEN",
    USER_INFO:'USER_INFO'
}